import { createContext, ReactNode, useContext } from "react";

import { TudigoError } from "@tudigo-monorepo/core-tudigo-api";
import { Reporting } from "@tudigo-monorepo/core-tudigo-api-models";

import { AutoPublishFormValues } from "../components/reporting-auto-publish-form/form-schema";
import { PublishFormValues } from "../components/reporting-publish-form/form-schema";

type BackOfficeReportingDetailPageContextType = {
  reportingFormData: Reporting;
  setReportingFormData: (reporting: Reporting) => void;
  updateError: TudigoError | null;
  setUpdateError: (error: TudigoError | null) => void;
  previewBeforePublish: () => void;
  saveReportingForm: () => void;
  openPublishModal: () => void;
  openAutoPublishModal: () => void;
  unPublishReportingForm: () => void;
  publishReportingForm: (values: PublishFormValues) => void;
  autoPublishReportingForm: (values: AutoPublishFormValues) => void;
};

const BackOfficeReportingDetailPageContext =
  createContext<BackOfficeReportingDetailPageContextType | null>(null);

function useBackOfficeReportingDetailPageContext() {
  const context = useContext(BackOfficeReportingDetailPageContext);
  if (context === null) {
    throw new Error(
      "useBackOfficeReportingDetailPageContext must be used within a Provider",
    );
  }
  return context;
}

const BackOfficeReportingDetailPageProvider = ({
  children,
  value,
}: {
  children: ReactNode;
  value: BackOfficeReportingDetailPageContextType;
}) => {
  return (
    <BackOfficeReportingDetailPageContext.Provider value={value}>
      {children}
    </BackOfficeReportingDetailPageContext.Provider>
  );
};

export {
  useBackOfficeReportingDetailPageContext,
  BackOfficeReportingDetailPageProvider,
};
